import React, { useState, useEffect } from "react";
import { SearchResult, Docs } from "../Types/SearchResult.interface";
import { GetLastestBooks } from "../Services/Books.service";
import "../Styles/Index.css";
import {RecentChange} from "../Types/LastestChanges.interface";
import {GetRecentChanges} from "../Services/Changes.service";
export default function IndexPage() {
    const [latestBooks, setLatestBooks] = useState<SearchResult | null>(null);
    const [recentChanges, setRecentChanges] = useState<RecentChange[]>([]);
    const [loadingBooks, setLoadingBooks] = useState<boolean>(true);
    const [loadingChanges, setLoadingChanges] = useState<boolean>(true);

    useEffect(() => {
        async function fetchData() {
            try {
                const [books, changes] = await Promise.all([GetLastestBooks(), GetRecentChanges()]);
                setLatestBooks(books);
                setRecentChanges(changes);
                setLoadingBooks(false);
                setLoadingChanges(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoadingBooks(false);
                setLoadingChanges(false);
            }
        }
        fetchData();
    }, []);

    return (
        <div className="container">
            <h2 className={'page-title'}>Dernières publications</h2>
            {loadingBooks ? (
                <div role="status">
                    <span className="loader"></span>
                </div>
            ) : (
                <div className="book-scroll">
                    {latestBooks && (
                        <ul className="book-list">
                            {latestBooks.docs.map((book: Docs, index: number) => (
                                <li key={index} className="book-item">
                                    <a href={book.key ? book.key : "#"} className="book-link">
                                        <img
                                            className={"lastBook"}
                                            src={`https://covers.openlibrary.org/b/id/${book.cover_i}-M.jpg`}
                                        />
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
            <h2 className={'page-title'}>Dernières Modifications apportées</h2>
            {loadingChanges ? (
                <div role="status">
                    <span className="loader"></span>
                </div>
            ) : (
                <div className="change-scroll">
                    <ul className="change-list">
                        {recentChanges.map((change: RecentChange, index: number) => (
                            <li key={index} className="change-item">
                                <div className="change-link">
                                    <p>Kind: {change.kind}</p>
                                    <p>Author: {change.author.key.slice(8)}</p>
                                    <p>Timestamp: {change.timestamp}</p>
                                    <p>Comment: {change.comment}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
